import { createApp } from 'vue';

import router from './router';
import App from './App.vue';
import BaseCard from './components/ui/BaseCard.vue';
import BaseDialog from './components/ui/BaseDialog.vue';
import activateBulmaBurger from './shared/bulma-burger.js';
import store from './store';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChevronDown, faChevronRight, faCheck } from '@fortawesome/free-solid-svg-icons';

import '../css/main.css';

activateBulmaBurger();

library.add(faChevronDown, faChevronRight, faCheck);

const app = createApp(App);

app.use(router);
app.use(store);

app.component('base-card', BaseCard);
app.component('base-dialog', BaseDialog);
app.component('font-awesome-icon', FontAwesomeIcon);

app.mount('#app');
